import React from 'react'
import '../common/styles/styles.css'

function Underline() {
  return (
    <div className='underlinee'></div>
  )
}

export default Underline